import React__default from 'react';
import PropTypes from 'prop-types';

var tshirtSizes = ['none', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
var namedColors = ['primary-dark', 'primary-light', 'secondary-dark', 'secondary-light'];
var propTypes = {
  /**
   * Can be plain text or other components (including Container)
   */
  children: PropTypes.node.isRequired,
  /**
   * The background color from a predefined list of tokens
   */
  backgroundColor: PropTypes.oneOf(namedColors),
  /** Custom classes to extend styling */
  classList: PropTypes.string,
  /**
   * Determines the flow of content
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  /**
   * T-shirt sizes only. Controls bottom padding within the component.
   */
  paddingBottom: PropTypes.oneOf(tshirtSizes),
  /**
   * T-shirt sizes only. Controls left padding within the component.
   */
  paddingLeft: PropTypes.oneOf(tshirtSizes),
  /**
   * T-shirt sizes only. Controls right padding within the component.
   */
  paddingRight: PropTypes.oneOf(tshirtSizes),
  /**
   * T-shirt sizes only. Controls top padding within the component.
   */
  paddingTop: PropTypes.oneOf(tshirtSizes),
  /**
   * T-shirt sizes only. Controls spacing between components.
   */
  spacing: PropTypes.oneOf(tshirtSizes),
  /**
   * Controls text align within the Container.
   */
  textAlign: PropTypes.oneOf(['center', 'left', 'right'])
};
function Container(_ref) {
  var backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'vertical' : _ref$orientation,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 'none' : _ref$paddingBottom,
    _ref$paddingLeft = _ref.paddingLeft,
    paddingLeft = _ref$paddingLeft === void 0 ? 'none' : _ref$paddingLeft,
    _ref$paddingRight = _ref.paddingRight,
    paddingRight = _ref$paddingRight === void 0 ? 'none' : _ref$paddingRight,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 'none' : _ref$paddingTop,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ds1892-container ".concat(classList),
    "data-background-color": backgroundColor,
    "data-orientation": orientation,
    "data-padding-bottom": paddingBottom,
    "data-padding-left": paddingLeft,
    "data-padding-right": paddingRight,
    "data-padding-top": paddingTop,
    "data-spacing": spacing,
    "data-text-align": textAlign
  }, children);
}
Container.propTypes = propTypes;

export { Container as default };
//# sourceMappingURL=Container.js.map
